var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var InstagramFeedNode_1, FeedNode_1;
import { GraphQLURL } from "graphql-scalars";
import { DateTime } from "luxon";
import { Field, InterfaceType, ObjectType } from "type-graphql";
import { Node } from "../relay.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { ImageNode } from "./Image.js";
import { TimestampedResource } from "./Resource.js";
// TODO: Expand this to include more types of feed items
// export const FeedResourceType = {
//   FeaturedImage: "FeaturedImage",
// } as const;
// export type FeedItemType = (typeof FeedResourceType)[keyof typeof FeedResourceType];
// registerEnumType(FeedResourceType, {
//   name: "FeedResourceType",
//   description: "Dictates how to interpret the resource link",
// });
let FeedItem = class FeedItem {
    id;
    title;
    textContent;
    image;
    link;
    createdAt;
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], FeedItem.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], FeedItem.prototype, "title", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], FeedItem.prototype, "textContent", void 0);
__decorate([
    Field(() => ImageNode, { nullable: true }),
    __metadata("design:type", Object)
], FeedItem.prototype, "image", void 0);
__decorate([
    Field(() => GraphQLURL, { nullable: true }),
    __metadata("design:type", Object)
], FeedItem.prototype, "link", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", DateTime)
], FeedItem.prototype, "createdAt", void 0);
FeedItem = __decorate([
    InterfaceType()
], FeedItem);
export { FeedItem };
let InstagramFeedNode = InstagramFeedNode_1 = class InstagramFeedNode extends TimestampedResource {
    id;
    title;
    textContent;
    image;
    link;
    getUniqueId() {
        return this.id.id;
    }
    text() {
        return this.title;
    }
    static init(init) {
        return InstagramFeedNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], InstagramFeedNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], InstagramFeedNode.prototype, "title", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], InstagramFeedNode.prototype, "textContent", void 0);
__decorate([
    Field(() => ImageNode, { nullable: true }),
    __metadata("design:type", Object)
], InstagramFeedNode.prototype, "image", void 0);
__decorate([
    Field(() => GraphQLURL, { nullable: true }),
    __metadata("design:type", Object)
], InstagramFeedNode.prototype, "link", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], InstagramFeedNode.prototype, "text", null);
InstagramFeedNode = InstagramFeedNode_1 = __decorate([
    ObjectType({
        implements: [Node, FeedItem],
    })
], InstagramFeedNode);
export { InstagramFeedNode };
let FeedNode = FeedNode_1 = class FeedNode extends TimestampedResource {
    id;
    title;
    textContent;
    getUniqueId() {
        return this.id.id;
    }
    text() {
        return this.title;
    }
    static init(init) {
        return FeedNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], FeedNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], FeedNode.prototype, "title", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], FeedNode.prototype, "textContent", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], FeedNode.prototype, "text", null);
FeedNode = FeedNode_1 = __decorate([
    ObjectType({
        implements: [Node, FeedItem],
    })
], FeedNode);
export { FeedNode };
//# sourceMappingURL=Feed.js.map